const state = {
  user: null,
  groups: null,
  isAdmin: false
}

const mutations = {
  __reset (state) {
    state.user = null
    state.groups = null
    state.isAdmin = false
  },
  setUser (state, user) {
    state.user = user
  },
  setGroups (state, groups) {
    state.groups = groups
    if (groups && groups.indexOf('admin') > -1) {
      state.isAdmin = true
    } else {
      state.isAdmin = false
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations
}
